export default __webpack_public_path__ + "static/media/hotel_rewardUnlock.726372f4.png";